/**
 * @module Models
 *
 */
import { Model } from "typedefs";

/**
 * `SubscriptionPlanModel`
 *
 */
export interface SubscriptionPlanModel extends Model {
  id?:
    | "coachpro+monthly"
    | "coachpro+yearly"
    | "coach+monthly"
    | "coach+yearly"
    | "coach+enterprise"
    | "coachacademy+monthly"
    | "coachacademy+yearly"
    | "analyze+monthly"
    | "analyze+yearly";
  amount?: number;
  currency?: string;
  productKind?: "CoachPlus" | "Academy" | "Analyze";
  termKind?: "Monthly" | "Yearly" | "Enterprise";
  coupon?: string;
}

export enum SubscriptionSource {
  STRIPE = "stripe",
  APPLE = "apple",
  GOOGLE = "google",
  OTHER = "other",
}

export enum SubscriptionStatus {
  TRIAL = "trial",
  ACTIVE = "active",
  CANCELED = "canceled",
  EXPIRED = "expired",
  PAUSED = "paused",
}

export enum CustomerType {
  STRIPE = "stripe",
  APPLE = "apple",
  GOOGLE = "google",
  LEGACY = "legacy",
}

/**
 * user subscription state interface
 */
export interface UserSubscriptionState {
  hasActiveStripeSubscription: boolean;
  hasStripeAccountType: boolean;
  hasLicensedSubscription: boolean;
  hasActiveTrialOrSubscription: boolean;
  userHasCanceled: boolean;
}

/**
 * plan information from user model
 */
export interface UserPlan {
  source?: string;
  status?: string;
  licensed?: boolean;
  canceledAt?: string | null;
  expiresAt?: string | null;
}

/**
 * user model subset needed for subscription checks
 */
export interface SubscriptionUser {
  plan?: UserPlan;
  customerType?: string;
  hasActiveSubscription?: boolean;
}
